import React, {
  useState,
  useEffect,
  Fragment,
  useCallback,
  useContext,
  location,
} from "react";
import Layout from "../../../../../../components/sales/layout/layout";
import TableSection from "../../../../../../components/sales/tableSection/tableSection";
import { BaseUrl } from "../../../../../../contexts/baseUrl/baseUrl";
import { Button } from "react-bootstrap";
import Images from "../../../../../../assets/images/imageData";
import localization from "../../../../../../assets/localization/localization";
import ListFilters from "../../../../../../components/sales/ListFilters/ListFilters";

const B2B = ({ rcCaseListingRequest, match, rcCaseListingResponse = [] }) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [roleId, setRoleId] = useState();
  const [userId, setUserId] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [listData, setListData] = useState();
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setUserId(JSON.parse(window.localStorage.loginDetails)?.id);
      setRoleId(window.localStorage.getItem("fusion-role"));

      const data = JSON.parse(localStorage.getItem("rc_b2b_filter") || "{}");
      const page = parseInt(localStorage.getItem("rc_b2b_page")) || 1;

      setCurrentPage(page);
      await rcCaseListingRequest(page, "LOAN_B2B", data);
      setIsLoading(false);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const headers = [
    "Vehicle No",
    "Channel Name",
    "Customer Name",
    "Loan Type",
    "Case Id",
    "Current RTO State",
    "Disbursal Date",
    "Aging",
    "RC Transfer By",
    "Action",
  ];

  const onPageChange = async (val) => {
    const selectedPage = val.selected + 1;
    setIsLoading(true);
    setCurrentPage(selectedPage);
    localStorage.setItem("rc_b2b_page", selectedPage);

    const storedData = window.localStorage?.rc_b2b_filter;
    const data = storedData ? JSON.parse(storedData) : {};

    await rcCaseListingRequest(selectedPage, "LOAN_B2B", data);
    setIsLoading(false);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    localStorage.setItem("rc_b2b_filter", JSON.stringify(filterData));
    localStorage.setItem('rc_b2b_page', 1); 
    setCurrentPage(1)
    setFilterData(filterData);
    await rcCaseListingRequest(1, "LOAN_B2B", filterData);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
      <>
        <Fragment>
          <Button
            onClick={filterToggle}
            className="filter-hamburger btn btn-transparent"
          >
            <img src={Images?.Filter} alt=""></img>
            {localization.showFilters}
          </Button>
        </Fragment>
      </>
    );
  };

  useEffect(() => {
    setListData();
    if (
      rcCaseListingResponse &&
      rcCaseListingResponse?.data &&
      rcCaseListingResponse?.data &&
      rcCaseListingResponse?.data?.listing.length > 0
    ) {
      const tableData = [
        "id",
        "vehicle_number",
        "channel_name",
        "customer_name",
        "loan_type",
        "loan_id",
        "current_state",
        "current_state",
        "disbursal_date",
        "aging",
        "mediator"
      ];
      const data = rcCaseListingResponse?.data?.listing.map((element) =>
        Object.assign(...tableData.map((key) => ({ [key]: element[key] })), {
          Action: [
            {
              name: "View & Upload documents",
              link: `${baseUrl}/ucd/rc-case-view/${element["loan_id"]}/${element["application_id"]}`,
            },
            // {
            //   name: "Documents",
            //   link: `${baseUrl}/ucd/rc-documents/${element["loan_id"]}/${element["application_id"]}`,
            // },
          ],
        })
      );
      if (data) {
        data && setListData(data);
      }
      setPageCount(
        Math.ceil(
          rcCaseListingResponse?.total / rcCaseListingResponse?.per_page
        )
      );
    }
  }, [rcCaseListingResponse]);

  return (
    <>
      <Layout
        title={"B2B Case"}
        isLoading={isLoading}
        isGoback={true}
        Buttons={headerBtns}
      >
        <TableSection
          data={listData}
          isId={false}
          isMngId={false}
          headers={headers}
          pageCount={pageCount}
          onPageChange={onPageChange}
          detailList={rcCaseListingResponse?.data?.listing}
          srNo={rcCaseListingResponse?.from}
          forcePage={currentPage - 1}
          currentPage={currentPage}
        />
        <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          rcCasesFilter={true}
          listFilterData={rcCaseListingResponse?.data?.filters}
          localstorageKey={"rc_b2b_filter"}
        />
      </Layout>
    </>
  );
};

export default B2B;
